(function ($) {
  var HOST_SELECTOR = "#content .filters-wrapper .filter-section form fieldset";
  var INIT_ATTR = "data-custom-scrollbar-init";

  function injectStyles() {
    if ($("#custom-scrollbar-styles").length) {
      return;
    }

    var css = [
      "#content .filters-wrapper .filter-section form .custom-scrollbar-wrapper { position: relative; }",
      "#content .filters-wrapper .filter-section form fieldset.custom-scrollbar-target { scrollbar-width: none !important; -ms-overflow-style: none; }",
      "#content .filters-wrapper .filter-section form fieldset.custom-scrollbar-target::-webkit-scrollbar { width: 0 !important; height: 0 !important; display: none !important; }",
      "#content .filters-wrapper .filter-section form .custom-scrollbar-wrapper .custom-scrollbar-track { position: absolute; top: 0; right: 0; width: 10px; height: 100%; background: #eaeaea; border-radius: 360px; }",
      "#content .filters-wrapper .filter-section form .custom-scrollbar-wrapper .custom-scrollbar-thumb { position: absolute; right: 2px; width: 6px; background: #202020; border-radius: 360px; cursor: pointer; }",
    ].join("\n");

    $("<style>", { id: "custom-scrollbar-styles", text: css }).appendTo("head");
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function updateScrollbar(host) {
    var $host = $(host);
    var $wrapper = $host.parent(".custom-scrollbar-wrapper");
    var $track = $wrapper.children(".custom-scrollbar-track").first();
    var $thumb = $track.children(".custom-scrollbar-thumb").first();

    if (!$track.length || !$thumb.length) {
      return;
    }

    var viewportHeight = host.clientHeight;
    var contentHeight = host.scrollHeight;

    if (!viewportHeight || contentHeight <= viewportHeight) {
      $track.hide();
      return;
    }

    $track.show();

    var trackHeight = $track[0].clientHeight;
    var thumbHeight = Math.max(24, Math.round((viewportHeight / contentHeight) * trackHeight));
    var maxThumbTop = Math.max(0, trackHeight - thumbHeight);
    var maxScrollTop = Math.max(1, contentHeight - viewportHeight);
    var thumbTop = Math.round((host.scrollTop / maxScrollTop) * maxThumbTop);

    $thumb.css({
      height: thumbHeight + "px",
      top: thumbTop + "px",
    });
  }

  function bindDrag(host, $track, $thumb) {
    var dragging = false;
    var startY = 0;
    var startTop = 0;

    function onPointerMove(event) {
      if (!dragging) {
        return;
      }

      var deltaY = event.clientY - startY;
      var trackHeight = $track[0].clientHeight;
      var thumbHeight = $thumb.outerHeight();
      var maxThumbTop = Math.max(0, trackHeight - thumbHeight);
      var nextThumbTop = clamp(startTop + deltaY, 0, maxThumbTop);
      var maxScrollTop = Math.max(1, host.scrollHeight - host.clientHeight);

      host.scrollTop = (nextThumbTop / Math.max(1, maxThumbTop)) * maxScrollTop;
      updateScrollbar(host);
    }

    function onPointerUp() {
      dragging = false;
      $(document).off("pointermove.customScrollbar", onPointerMove);
      $(document).off("pointerup.customScrollbar", onPointerUp);
    }

    $thumb.on("pointerdown.customScrollbar", function (event) {
      event.preventDefault();
      dragging = true;
      startY = event.clientY;
      startTop = parseFloat($thumb.css("top")) || 0;

      $(document).on("pointermove.customScrollbar", onPointerMove);
      $(document).on("pointerup.customScrollbar", onPointerUp);
    });

    $track.on("click.customScrollbar", function (event) {
      if ($(event.target).closest(".custom-scrollbar-thumb").length) {
        return;
      }

      var rect = $track[0].getBoundingClientRect();
      var clickY = event.clientY - rect.top;
      var thumbHeight = $thumb.outerHeight();
      var maxThumbTop = Math.max(0, $track[0].clientHeight - thumbHeight);
      var nextThumbTop = clamp(clickY - thumbHeight / 2, 0, maxThumbTop);
      var maxScrollTop = Math.max(1, host.scrollHeight - host.clientHeight);

      host.scrollTop = (nextThumbTop / Math.max(1, maxThumbTop)) * maxScrollTop;
      updateScrollbar(host);
    });
  }

  function initHost(host) {
    var $host = $(host);

    if ($host.attr(INIT_ATTR) === "1") {
      updateScrollbar(host);
      return;
    }

    $host.attr(INIT_ATTR, "1");
    $host.addClass("custom-scrollbar-target");

    if (!$host.css("overflow-y") || $host.css("overflow-y") === "visible") {
      $host.css("overflow-y", "auto");
    }
    $host.css("overflow-x", "hidden");

    if (!$host.parent().hasClass("custom-scrollbar-wrapper")) {
      $host.wrap('<div class="custom-scrollbar-wrapper"></div>');
    }

    var $wrapper = $host.parent(".custom-scrollbar-wrapper");
    var $track = $("<span>", { class: "custom-scrollbar-track" });
    var $thumb = $("<span>", { class: "custom-scrollbar-thumb" });

    $track.append($thumb);
    $wrapper.append($track);

    $host.on("scroll.customScrollbar", function () {
      updateScrollbar(host);
    });

    bindDrag(host, $track, $thumb);
    updateScrollbar(host);
  }

  function initAll() {
    $(HOST_SELECTOR).each(function () {
      initHost(this);
    });
  }

  function updateAll() {
    $(HOST_SELECTOR + "[" + INIT_ATTR + "='1']").each(function () {
      updateScrollbar(this);
    });
  }

  function start() {
    injectStyles();
    initAll();
    updateAll();

    $(window).on("resize.customScrollbar", function () {
      updateAll();
    });

    $(document).on("click.customScrollbar", "#content .filters-wrapper .filter-section h4", function () {
      setTimeout(updateAll, 0);
      setTimeout(updateAll, 200);
    });

    var filtersRoot = document.querySelector("#content .filters-wrapper");
    if (filtersRoot && typeof MutationObserver === "function") {
      var observer = new MutationObserver(function () {
        initAll();
        updateAll();
      });

      observer.observe(filtersRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style"],
      });
    }
  }

  $(start);
})(jQuery);
